import React from "react";
import { FormControl, RadioGroup } from "@mui/material";
import { useField } from "formik";
import {
  StyledFormControlLabel,
  StyledFormHelperText,
  StyledFormLabel,
  StyledLabelSpan,
  StyledRadio,
} from "./style";

export default function RadioButtonsGroup({
  label,
  required,
  name,
  options = [],
}) {
  const [field, meta] = useField(name);

  return (
    <FormControl component="fieldset">
      <StyledFormLabel>
        {label} <StyledLabelSpan>{required ? "*" : ""}</StyledLabelSpan>
      </StyledFormLabel>
      <RadioGroup
        error={meta.touched && meta.error ? true : undefined}
        name={name}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
      >
        {options.map((option) => (
          <StyledFormControlLabel
            key={option.value}
            value={option.value}
            control={<StyledRadio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      {meta.touched && meta.error && (
        <StyledFormHelperText>{meta.error}</StyledFormHelperText>
      )}
    </FormControl>
  );
}
